// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-graphic .graphoc-content{position:relative;max-width:100%;margin-top:5px}.video-graphic .graphoc-content:last-child{margin-bottom:0}.video-graphic .graphoc-content img{max-width:100%;margin-top:20px;border-radius:8px}.video-graphic .graphoc-content img:last-child,.video-graphic .graphoc-content p:last-child{margin-bottom:0!important}", ""]);
// Exports
module.exports = exports;
